class PredictiveSearchComponent extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId || 'predictive-search';
    this.cache = {};
    this.debounceTimer = null;
    this.abortController = null;

    this.overlay = document.querySelector('.search-drawer-overlay');
    this.input = this.querySelector('.search-input');
    this.clearBtn = this.querySelector('[data-clear]');
    this.emptyState = this.querySelector('[data-empty-state]');
    this.suggestionsContainer = this.querySelector('[data-suggestions]');
    this.resultsContainer = this.querySelector('[data-results]');

    /* Drawer triggers */
    var self = this;
    document.querySelectorAll('.search-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () { self.open(); });
    });

    this.querySelector('[data-close]').addEventListener('click', function () {
      self.close();
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', function () { self.close(); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.close();
    });

    /* Predictive search on input */
    this.input.addEventListener('input', function () { self.onInput(); });

    /* Clear button */
    this.clearBtn.addEventListener('click', function () { self.reset(); });
  }

  open() {
    this.classList.add('active');
    if (this.overlay) this.overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    var input = this.input;
    requestAnimationFrame(function () { input.focus(); });
  }

  close() {
    this.classList.remove('active');
    if (this.overlay) this.overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  onInput() {
    var query = this.input.value.trim();
    this.clearBtn.hidden = !query;

    if (!query) {
      this.showEmptyState();
      return;
    }

    clearTimeout(this.debounceTimer);
    var self = this;
    this.debounceTimer = setTimeout(function () {
      self.fetchResults(query);
    }, 300);
  }

  fetchResults(query) {
    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();

    var cacheKey = query.toLowerCase();
    if (this.cache[cacheKey]) {
      this.renderResults(this.cache[cacheKey]);
      return;
    }

    var self = this;
    fetch(
      '/search/suggest?q=' + encodeURIComponent(query) +
      '&section_id=' + this.sectionId +
      '&resources[type]=product,query&resources[limit]=4',
      { signal: this.abortController.signal }
    )
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var section = parsed.querySelector('#shopify-section-' + self.sectionId);
        var markup = section ? section.innerHTML : '';
        self.cache[cacheKey] = markup;
        self.renderResults(markup);
      })
      .catch(function (e) {
        if (e.name !== 'AbortError') console.error(e);
      });
  }

  localizeLabels(fragment) {
    var title = fragment.querySelector('.suggestions-title');
    if (title && this.dataset.labelSuggestions) {
      title.textContent = this.dataset.labelSuggestions;
    }

    var empty = fragment.querySelector('.no-results');
    if (empty && this.dataset.labelNoProducts) {
      empty.textContent = this.dataset.labelNoProducts;
    }
  }

  renderResults(markup) {
    var temp = document.createElement('div');
    temp.innerHTML = markup;

    this.localizeLabels(temp);

    var root = window.Shopify.routes.root;
    if (root !== '/') {
      temp.querySelectorAll('a[href^="/"]').forEach(function (link) {
        var href = link.getAttribute('href');
        if (href.indexOf(root) !== 0)
          link.setAttribute('href', root + href.slice(1));
      });
    }

    var suggestions = temp.querySelector('[data-search-suggestions]');
    var products = temp.querySelector('[data-search-products]');

    if (suggestions) {
      this.suggestionsContainer.innerHTML = suggestions.innerHTML;
      this.suggestionsContainer.hidden = false;
    } else {
      this.suggestionsContainer.innerHTML = '';
      this.suggestionsContainer.hidden = true;
    }

    if (products) {
      this.resultsContainer.innerHTML = products.innerHTML;
      this.resultsContainer.hidden = false;
    } else {
      this.resultsContainer.innerHTML = '';
      this.resultsContainer.hidden = true;
    }

    this.emptyState.hidden = true;
  }

  reset() {
    this.input.value = '';
    this.clearBtn.hidden = true;
    this.showEmptyState();
    this.input.focus();
  }

  showEmptyState() {
    this.emptyState.hidden = false;
    this.suggestionsContainer.hidden = true;
    this.suggestionsContainer.innerHTML = '';
    this.resultsContainer.hidden = true;
    this.resultsContainer.innerHTML = '';
  }
}

customElements.define('predictive-search-component', PredictiveSearchComponent);
